
export enum UserRoles {
    Partner = 'Partner',
    Member = 'Member',
    Admin = 'Admin'
}

export type AuthRoles = UserRoles.Partner | UserRoles.Member | UserRoles.Admin